import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { NewThemeService } from '@wm-front/core-tools'
import {
  ThemeColors,
  SecondaryColors,
  ComponentSize,
} from '@wm-front/shared/enums'

@Component({
  selector: '[wm-front-button]', // eslint-disable-line
  template: `
    @if (themeIcon && newThemeEnabled()) {
    <mat-icon class="theme-icon" [svgIcon]="themeIcon"></mat-icon>
    }
    <ng-content></ng-content>
  `,
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
  imports: [MatIconModule],
})
export class ButtonComponent {
  /** The color of the button. 'ghost' is a text action with no fill and no border, 'link' a text link, 'upsell' a client sales prompt (orange in every theme) */
  @Input() public status:
    | ThemeColors
    | SecondaryColors
    | 'transparent'
    | 'ghost'
    | 'link'
    | 'upsell'
    | string

  /** The raised or flat condition of the button */
  @Input() public flat?: boolean

  /** Whether or not it is outline */
  @Input() public outline?: boolean

  /** Whether or not it should have borders */
  @Input() public borderless?: boolean

  /** The size of the button */
  @Input() public size?: ComponentSize | `${ComponentSize}`

  /** Whether or not it it is an icon button that needs to be square */
  @Input() public icon?: boolean

  /** conditionnal classes to add to the component */
  @Input() public classes?: string[]

  /** 2026 theme only (PRENG-8349): the icon drawn before the label, for example `validate-sm`. Flag off, none is drawn */
  @Input() public themeIcon?: string

  public newThemeEnabled = inject(NewThemeService).enabled

  protected _elementRef = inject(ElementRef)

  /** Whether or not the component should have the class 'outline' */
  @HostBinding(`class`)
  public get outlineClass(): string {
    let classNames = `${this.status}`

    if (this.outline) {
      classNames += ` outline-${this.status}`
    }

    if (this.flat) {
      classNames += ' flat'
    }

    if (this.borderless) {
      classNames += ' borderless'
    }

    if (this.icon) {
      classNames += ' icon'
    }

    if (this.size) {
      classNames += ` ${this.size}`
    }

    if (this.classes && this.classes.length) {
      this.classes.forEach((cssClass: string) => {
        classNames += ` ${cssClass}`
      })
    }

    return classNames
  }

  /** Listen the click for remove focus status */
  @HostListener('click')
  public click(): void {
    this._elementRef.nativeElement.blur()
  }
}
